import { DataTable, DataTablePagination } from 'components/common'
import { columns } from './utils'
import { useQuery } from 'hooks'
import { RowClickedEvent } from '@ag-grid-community/core'
import { useLocation, useNavigate } from 'react-router-dom'
import { PAGE_INVENTORY_UPDATE } from 'utils/constants'
import { memo, useEffect, useState } from 'react'
import { fetchInventoryDetails } from 'utils/api/inventoryApi'
import { SetSelectedColumns } from 'types/dataTable'

type Props = {
  isEditor: boolean
  setSelectedColumns: SetSelectedColumns
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const InventoryDataTable = ({
  loading,
  setLoading,
  isEditor,
  setSelectedColumns,
}: Props) => {
  const [inventoryResponse, setInventoryUpdate] = useState<any>({})

  const navigate = useNavigate()
  const { search } = useLocation()
  const { getAllQueries, setQuery } = useQuery()

  const getInventory = async () => {
    setLoading(true)
    const { limit, page, search, inventoryFilters } = getAllQueries()
    try {
      const { data } = await fetchInventoryDetails({
        limit: limit || 10,
        page: page || 1,
        search: search,
        filters: inventoryFilters,
      })
      setSelectedColumns(data?.tableConfig?.inventory || [])
      setInventoryUpdate({ ...data })
    } catch (error) {
      setInventoryUpdate({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getInventory()
  }, [search])

  useEffect(() => {
    const columnUrlParams = localStorage.getItem('inventoryColumnSelected')
    if (columnUrlParams) {
      setQuery('cols', JSON.parse(columnUrlParams))
    }
  }, [])

  const onRowClicked = (e: RowClickedEvent) => {
    if (!isEditor) return
    navigate(`${PAGE_INVENTORY_UPDATE.path}/${e.data._id}`)
  }

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : inventoryResponse?.docs}
        onRowClicked={isEditor ? onRowClicked : () => {}}
        identifier="_id"
        activeColumnsKey="inventory"
        activeColumns={inventoryResponse?.tableConfig?.inventory || []}
      />

      <DataTablePagination
        currentPage={inventoryResponse?.page}
        totalPages={inventoryResponse?.totalPages}
        hasNextPage={inventoryResponse?.hasNextPage}
        hasPrevPage={inventoryResponse?.hasPrevPage}
        limit={inventoryResponse?.limit}
        nextPage={inventoryResponse?.nextPage}
        prevPage={inventoryResponse?.prevPage}
        disabled={loading}
        disableGoToLastPage
        shouldDisplayTotalPages={false}
      />
    </>
  )
}

export default memo(InventoryDataTable)
